// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  events: [],
  activeEvents: [],
  event: {},
  prevEvent: {},
  reasons: {},
  venue: {},
  venueCityImages: [],
  session: {},
  sponsors: {},
  eventAllSponsors: [],
  parallelEvents: {},
  accommodations: {},
  speakersList: {
    keynoteSpeakers: [],
    moderators: [],
    panelist: [],
  },
  exhibitors: [],
  bookedTables: [],
  meetingRooms: [],
  mediaDocs: {},
  participantMembers: [],
  participantCompanies: [],
  participantMembersCount: 0,
  eventPrices: [],
  awardPrices: [],
};

// Create a new store
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
